import React from "react"

import { gql, useQuery } from "urql"

import { AlertLevel } from "~tailwindui/types/enums"

import { AlertMessageBox, H2, WithLoadingIndicator } from "~tailwindui/Basics"

import ReplacementCard from "./ReplacementCard"

const AvailableStudyGroupReplacements = () => {
  const [result] = useQuery({
    query: availableStudyGroupReplacementsQuery,
  })

  return (
    <div>
      <AlertMessageBox level={AlertLevel.Info}>
        When a tutor gives up a group that you are eligible to accept, that
        group will appear here.
      </AlertMessageBox>

      <WithLoadingIndicator result={result}>
        {({ data: { viewer } }) => (
          <>
            {viewer.recentlyGaveUpGroup ? (
              <AlertMessageBox level={AlertLevel.Warning}>
                You have given up a study group in the last 48 hours, so you are
                ineligible to accept new groups at this time.
              </AlertMessageBox>
            ) : null}

            <H2>Study Group Replacements</H2>
            {viewer.availableStudyGroupReplacements.length === 0 ? (
              <span className="mb-8 text-lg italic">
                No study group replacements are available at this time.
              </span>
            ) : (
              <div className="flex flex-wrap gap-10">
                {viewer.availableStudyGroupReplacements.map(replacement => (
                  <ReplacementCard
                    key={replacement.id}
                    replacement={replacement}
                  />
                ))}
              </div>
            )}
          </>
        )}
      </WithLoadingIndicator>
    </div>
  )
}

const availableStudyGroupReplacementsQuery = gql`
  query AvailableStudyGroupReplacements {
    viewer {
      recentlyGaveUpGroup
      availableStudyGroupReplacements {
        id
        startsAt
        details
        originalTutor {
          id
          fullName
        }
        studyGroup {
          id
          name
          subjects {
            id
            name
          }
          courseSection {
            id
            endsOn
          }
          foreignLanguage {
            id
            name
          }
          allAvailabilities {
            id
            startsAt
            endsAt
            weekday
          }
          organization {
            id
            name
            details
            emailTimeZone
          }
        }
      }
    }
  }
`

export default AvailableStudyGroupReplacements
